export enum CalculationFormSidebarViewEnum {
  TableOfContents = 'TABLE_OF_CONTENTS',
  Errors = 'ERRORS',
}
